import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'ResourcesListHorizontal',
};

import { useContext } from '@nuxtjs/composition-api';
import VueHorizontal from 'vue-horizontal';
import { Resource } from '@/types/resource';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import Card from '~/components/card/Card.vue';

interface Props {
  resources: Resource[];
  title?: string;
  subheading?: string;
  align?: string;
  link?: string;
  isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    resources: null,
    title: { default: '' },
    subheading: { default: '' },
    align: { default: 'left' },
    link: { default: '' },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { resources: Resource[], title: string, subheading: string, align: string, link: string, isLoading?: boolean };



return { __sfc: true,props, VueHorizontal, TLinkButton, Card }
}

})